import { render } from "./StatusBadge.vue?vue&type=template&id=5de08003&scoped=true"
import script from "./StatusBadge.vue?vue&type=script&lang=js"
export * from "./StatusBadge.vue?vue&type=script&lang=js"

import "./StatusBadge.vue?vue&type=style&index=0&id=5de08003&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de08003"]])

export default __exports__